import "core-js/modules/es.array.join";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { kickPlayerOffline } from "@/api/gmToolNew/gmToolNew";
import { gmToolNew, gmToolNewPage, gmToolNewCom } from "@/mixins/index";
export default {
  mixins: [gmToolNew, gmToolNewPage, gmToolNewCom],
  data: function data() {
    return {
      dialogShow: false,
      paramsData: {
        server_id: '',
        reason: ''
      },
      reasonList: [{
        label: this.$t('otherClientLogin'),
        value: 1
      }, {
        label: this.$t('accountBlacklist'),
        value: 2
      }, {
        label: this.$t('clientUpdateResource'),
        value: 3
      }, {
        label: this.$t('serverMaintenance'),
        value: 4
      }],
      rules: {
        server_id: [{
          required: true,
          message: this.$t('pleaseSelectServer'),
          trigger: "blur"
        }],
        reason: [{
          required: true,
          message: this.$t('pleaseSelectReason'),
          trigger: "blur"
        }],
        mode: [{
          required: true,
          message: this.$t('pleaseSelect'),
          trigger: "blur"
        }]
      }
    };
  },
  created: function created() {},
  methods: {
    open: function open() {
      this.dialogShow = true;
      this.paramsData.env_id = this.szgmEnv.length ? this.szgmEnv[0].id : '';
    },
    clearData: function clearData() {
      this.paramsData = {
        server_id: '',
        reason: '',
        mode: '',
        server_channel: '',
        show_test: ''
      };
      this.$refs.ruleForm.clearValidate();
    },
    hiad: function hiad() {
      this.dialogShow = false;
    },
    dataFormSubmit: function dataFormSubmit() {
      var _this = this;

      if (this.paramsData.server_id.length == 0) {
        this.$message.error(this.$t('pleaseSelectServer'));
        return;
      }

      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          kickPlayerOffline(_objectSpread(_objectSpread({}, _this.paramsData), {}, {
            server_id: _this.paramsData.server_id.join(",")
          })).then(function (res) {
            if (res.status == 200) {
              _this.$message({
                message: _this.$t('operationSuccess'),
                type: 'success'
              });

              _this.dialogShow = false;

              _this.$emit('update');
            }
          });
        }
      });
    }
  }
};